import { render, staticRenderFns } from "./StaffBankAccountNew.vue?vue&type=template&id=18aa803b"
import script from "./StaffBankAccountNew.vue?vue&type=script&lang=js"
export * from "./StaffBankAccountNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports